/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performCmdbDeleteRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getCmdbConfigReferenceTypeByIdUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbConfigReferenceTypeUrl.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { ReferenceType, ActionApi } from './ActionApi.types.tsx';

export const deleteReferenceType =
	(referenceType: ReferenceType): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		const state = getState();

		setState({
			...state,
			referenceTypes: { ...state.referenceTypes, deleteLoading: true },
		});

		try {
			await performCmdbDeleteRequest(
				getCmdbConfigReferenceTypeByIdUrl(workspaceId, referenceType.id),
			);

			setState({
				...state,
				referenceTypes: {
					...state.referenceTypes,
					deleteLoading: false,
					data: state.referenceTypes.data
						? state.referenceTypes.data.filter(({ id }) => id !== referenceType.id)
						: undefined,
				},
			});

			fireTrackAnalytics(createAnalyticsEvent({}), 'deleteReferenceType succeeded');
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				...state,
				referenceTypes: {
					...state.referenceTypes,
					deleteLoading: false,
					deleteError: error,
				},
			});

			fireCmdbErrorAnalytics({
				meta: {
					id: 'deleteReferenceType',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
					teamName: 'astral',
				},
				error,
			});

			throw error;
		}
	};
